import { render } from "./payrolls.vue?vue&type=template&id=2641ab21&scoped=true"
import script from "./payrolls.vue?vue&type=script&lang=js"
export * from "./payrolls.vue?vue&type=script&lang=js"

import "./payrolls.vue?vue&type=style&index=0&id=2641ab21&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2641ab21"]])

export default __exports__